export const selectedData = {
    manufacturer: '',
    category: '',
    type: '',
    year: '',
    hours: '',
    features: '',
    isSpecial: false,
    isOld: false
};